export const MODULE_NAME = 'snippets';
export const SNIPPET = 'Snippet';
export const SET_SNIPPET = 'SetSnippet';

export const SNIPPETS = 'Snippets';
export const SET_SNIPPETS = 'SetSnippets';
export const UPDATE_SNIPPET = 'UpdateSnippet';
export const DELETE_SNIPPET = 'DeleteSnippet';

export const SNIPPET_HISTORY_LOGS = 'snippetHistoryLogs';
export const SET_SNIPPET_HISTORY_LOGS = 'SetSnippetHistoryLogs';

import { TOAST_MESSAGES_PUSH as toastMessagesPush } from '@/sections/toast-mutation-types';

export const TOAST_MESSAGES_PUSH = toastMessagesPush;
